import type { SVGProps } from 'react';

const SvgToolOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.112 3.915a4.85 4.85 0 0 0-5.235 6.781.81.81 0 0 1-.165.905L4.196 18.12a1.192 1.192 0 1 0 1.686 1.686l6.518-6.517a.81.81 0 0 1 .905-.165 4.852 4.852 0 0 0 6.781-5.235l-2.615 2.615a1.75 1.75 0 0 1-2.453 0l-.005-.005-1.515-1.515a1.75 1.75 0 0 1 0-2.453l.005-.005zm-1.974-1.582a6.47 6.47 0 0 1 3.825.47.81.81 0 0 1 .239 1.309L14.65 7.664a.135.135 0 0 0 0 .185l1.5 1.501a.135.135 0 0 0 .186 0l3.552-3.552a.81.81 0 0 1 1.308.239 6.467 6.467 0 0 1-8.03 8.77l-6.142 6.141a2.81 2.81 0 1 1-3.973-3.972l6.142-6.142a6.468 6.468 0 0 1 4.945-8.5"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgToolOutlined;
